import {
  COMPANY_FILTER_CHANGE,
  FETCH_SELECTED_COMPANY_DATA_ASYNC,
} from 'containers/PartnerOptions/constants'

import {
  CLEAR_ALL_VALUES,
  FETCH_ALL_TAGS_ASYNC,
  FETCH_DEPARTMENTS_ASYNC,
  FETCH_TITLES_ASYNC,
  SET_ALL_TAGS_PAGE,
  SET_ALL_TAGS_SEARCH,
  SET_DEPARTMENTS_PAGE,
  SET_DEPARTMENTS_SEARCH,
  SET_SELECTED_ALL_TAGS,
  SET_SELECTED_DEPARTMENT,
  SET_SELECTED_TITLE,
  SET_TITLES_PAGE,
  SET_TITLES_SEARCH,
} from './constants'

const defaultTagsObject = {
  items: [],
  page: 1,
  search: '',
  loader: false,
  error: null,
  totalPages: 1,
}

export default function () {
  const initialState = {
    allTags: { ...defaultTagsObject },
    selectedAllTags: [],
    titles: { ...defaultTagsObject },
    selectedTitle: null,
    departments: { ...defaultTagsObject },
    selectedDepartments: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
      case COMPANY_FILTER_CHANGE:
        return {
          allTags: { ...defaultTagsObject },
          titles: { ...defaultTagsObject },
          departments: { ...defaultTagsObject },
        }
      case FETCH_ALL_TAGS_ASYNC.INITIATE:
        return {
          ...state,
          allTags: {
            ...state.allTags,
            loader: true,
            error: null,
          },
        }
      case FETCH_ALL_TAGS_ASYNC.SUCCESS: {
        const tags = action.payload.data.tags.map((elem) => ({
          name: elem.name,
          id: elem.id,
          type: elem.auto_tag_type,
        }))

        return {
          ...state,
          allTags: {
            ...state.allTags,
            items: state.allTags.page === 1 ? tags : [...state.allTags.items, ...tags],
            totalPages: action.payload.data.lastPageNum,
            loader: false,
          },
        }
      }
      case FETCH_ALL_TAGS_ASYNC.ERROR:
        return {
          ...state,
          allTags: {
            ...state.allTags,
            loader: false,
            error: action.error,
          },
        }
      case FETCH_ALL_TAGS_ASYNC.CANCEL:
        return {
          ...state,
          allTags: {
            ...state.allTags,
            loader: false,
          },
        }
      case SET_ALL_TAGS_PAGE:
        return {
          ...state,
          allTags: {
            ...state.allTags,
            page: action.payload.page,
          },
        }
      case SET_ALL_TAGS_SEARCH:
        return {
          ...state,
          allTags: {
            ...state.allTags,
            search: action.payload.search,
          },
        }
      case SET_SELECTED_ALL_TAGS:
        return {
          ...state,
          selectedAllTags: action.payload.value.map((elem) => elem.value),
        }
      case FETCH_TITLES_ASYNC.INITIATE:
        return {
          ...state,
          titles: {
            ...state.titles,
            loader: true,
            error: null,
          },
        }
      case FETCH_TITLES_ASYNC.SUCCESS: {
        const tags = action.payload.data.tags.map((elem) => ({
          name: elem.name,
          id: elem.id,
          type: elem.auto_tag_type,
        }))

        return {
          ...state,
          titles: {
            ...state.titles,
            items: state.titles.page === 1 ? tags : [...state.titles.items, ...tags],
            totalPages: action.payload.data.lastPageNum,
            loader: false,
          },
        }
      }
      case FETCH_TITLES_ASYNC.ERROR:
        return {
          ...state,
          titles: {
            ...state.titles,
            loader: false,
            error: action.error,
          },
        }
      case FETCH_TITLES_ASYNC.CANCEL:
        return {
          ...state,
          titles: {
            ...state.titles,
            loader: false,
          },
        }
      case SET_TITLES_PAGE:
        return {
          ...state,
          titles: {
            ...state.titles,
            page: action.payload.page,
          },
        }
      case SET_TITLES_SEARCH:
        return {
          ...state,
          titles: {
            ...state.titles,
            search: action.payload.search,
          },
        }
      case SET_SELECTED_TITLE:
        return {
          ...state,
          selectedTitle: action.payload.value,
        }
      case FETCH_DEPARTMENTS_ASYNC.INITIATE:
        return {
          ...state,
          departments: {
            ...state.departments,
            loader: true,
            error: null,
          },
        }
      case FETCH_DEPARTMENTS_ASYNC.SUCCESS: {
        const tags = action.payload.data.tags.map((elem) => ({
          name: elem.name,
          id: elem.id,
          type: elem.auto_tag_type,
        }))

        return {
          ...state,
          departments: {
            ...state.departments,
            items: state.departments.page === 1 ? tags : [...state.departments.items, ...tags],
            totalPages: action.payload.data.lastPageNum,
            loader: false,
          },
        }
      }
      case FETCH_DEPARTMENTS_ASYNC.ERROR:
        return {
          ...state,
          departments: {
            ...state.departments,
            loader: false,
            error: action.error,
          },
        }
      case FETCH_DEPARTMENTS_ASYNC.CANCEL:
        return {
          ...state,
          departments: {
            ...state.departments,
            loader: false,
          },
        }
      case SET_DEPARTMENTS_PAGE:
        return {
          ...state,
          departments: {
            ...state.departments,
            page: action.payload.page,
          },
        }
      case SET_DEPARTMENTS_SEARCH:
        return {
          ...state,
          departments: {
            ...state.departments,
            search: action.payload.search,
          },
        }
      case SET_SELECTED_DEPARTMENT:
        return {
          ...state,
          selectedDepartment: action.payload.value,
        }
      case CLEAR_ALL_VALUES:
        return {
          ...state,
          selectedAllTags: [],
          selectedTitle: null,
          selectedDepartment: null,
        }
      default:
        return state
    }
  }
}
